import { useState, useEffect, useCallback } from 'react'

export const useDispenseUnits = ({ apiClasses }) => {
    const [dispenseUnits, setDispenseUnits] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const fetchDispenseUnits = useCallback(async () => {
        if (!apiClasses?.PrescriptionsAPI?.getAllAvailableDispenseUnits) {
            return
        }
                
        setLoading(true)
        setError(null)
        
        try {
            const { data } = await apiClasses.PrescriptionsAPI.getAllAvailableDispenseUnits()
            setDispenseUnits(data?.units || [])
        } catch (error) {
            console.error("Error fetching dispense units:", error)
            setError(error.message || "Failed to fetch dispense units")
        } finally {
            setLoading(false)
        }
    }, [apiClasses])

    const getDispenseUnitById = useCallback((unitId) => {
        return dispenseUnits.find(unit => 
            unit.StandardDispenseUnitTypeID?.toString() === unitId?.toString()
        )
    }, [dispenseUnits])

    useEffect(() => {
        fetchDispenseUnits()
    }, [fetchDispenseUnits])

    return {
        dispenseUnits,
        loading,
        error,
        fetchDispenseUnits,
        getDispenseUnitById,
    }
}
